// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"39bb0775","845":"d1ba821e"}[chunkId] + ".chunk.js";
};